import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ReportDefinition, ReportDefinitionCreate, ReportDefinitionFilter } from '../data/reportDefinition';

export function createReportDefinitionService(client: AxiosInstance) {
  return createCrudService<ReportDefinition, ReportDefinitionCreate, ReportDefinitionFilter>(
    client,
    '/reporting/ReportDefinition',
    'id',
  );
}

export type ReportDefinitionService = CrudService<ReportDefinition, ReportDefinitionCreate, ReportDefinitionFilter>;
